import React from "react";
import Page from "components/Page";
import { Props } from "./Sites";
import { lazyWithRetry } from "helpers/lazyWithRetry";

const Sites = lazyWithRetry(() => import("./Sites"));

export default (props: Props) => (
  <Page>
    <Sites {...props} />
  </Page>
);
